// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'swiper/dist/css/swiper.css';
Vue.config.productionTip = false
import axios from 'axios'
Vue.prototype.$http = axios
Vue.config.productionTip = false
axios.defaults.baseURL ="http://webapi.zqjsgs.com/"
//axios.defaults.baseURL = "http://39.100.229.11:8102"

import {post,get} from './request/http'
import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
Vue.use(Toast, {
  defaultType: 'center',
  duration: 3000,
  wordWrap: true,
  width: '150px'
});
//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$get=get;

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js